import { AnalyticsService } from "@app/util/analytic/AnalyticsService";

export const companyAnalytics = new AnalyticsService("Add New Company");
export const personAnalytics = new AnalyticsService("Add New Person");
export const dealAnalytics = new AnalyticsService("Add New Deal");
export const activityAnalytics = new AnalyticsService("Add New Activity");
